import './publicPath'

const Vue = window.Vue

Vue.component('csaddtolist',    () => import('./app/components/CsAddToList.vue'))
Vue.component('csmodal',        () => import('./app/components/CsModal.vue'))
Vue.component('csacount',       () => import('./app/components/CsAccount.vue'))
Vue.component('cspublic',       () => import('./app/components/CsPublic.vue'))
Vue.component('csbasketsave',   () => import('./app/components/CsBasketSave.vue'))

